
import {
  defineComponent, reactive, watch, ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { routerArr } from '@/utils/base/getMenu';

export default defineComponent({
  setup(props, context) {
    const showClose = ref(false);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const baseRoute = {};
    let lastPath = '首页';
    const getPoint = (arr) => {
      arr.forEach((menu) => {
        baseRoute[menu.path] = true;
        if (menu.children && menu.children.length > 0) {
          getPoint(menu.children);
        }
      });
    };

    getPoint(routerArr);

    // 导航栏的数组
    const routeArr = reactive([{
      path: '/home', name: '首页', active: true,
    }]);

    const hasQuery = (str :string) => {
      const last = str.charAt(str.length - 1);
      const result = last === '?' ? true : last === '&';
      return result;
    };
    // 获取路由参数
    const getquery = (query) => {
      let str = '?';
      Object.keys(query).forEach((key) => {
        const specialSymbol = hasQuery(str);
        if (key === 'fromOrigin') {
          return;
        }
        str = specialSymbol ? str += `${key}=${query[key]}` : str += `&${key}=${query[key]}`;
      });
      return str === '?' ? '' : str;
    };
    // 重定向页面
    function toRedirect(item) {
      store.commit('SET_CACHE_COMPONENTS_PATH', item.path);
      router.push(item.path);
    }
    // 确定路由是否可以加入
    const canAdd = (path) => baseRoute[path];

    const getAddIndex = (params) => {
      const findPathIndex = routeArr.findIndex((item) => item.name === params.meta.title);
      const currentIndex = findPathIndex === -1 ? routeArr.findIndex((item) => item.name === lastPath) + 1 : findPathIndex + 1;
      return currentIndex;
    };
    // 往渲染的数组里加个数据
    function checkActive(params) {
      let flag = false;
      routeArr.forEach((item) => {
        const obj = item;
        if (params.meta.title === item.name) {
          obj.active = true;
          flag = true;
        } else {
          obj.active = false;
        }
      });
      const currentIndex = getAddIndex(params);
      lastPath = params.meta.title;
      const queryPath = params.path + getquery(route.query);
      if (routeArr.length === 1 && params.path !== '/home' && canAdd(params.path)) {
        // routeArr.push({ path: queryPath, name: params.meta.title, active: true });
        routeArr.splice(currentIndex, 0, { path: queryPath, name: params.meta.title, active: true });
        context.emit('userSelectPath', params.path);
        return;
      }
      // 标签栏中没有该标签 并且
      if (!flag && canAdd(params.path)) {
        // routeArr.push({ path: queryPath, name: params.meta.title, active: true });
        routeArr.splice(currentIndex, 0, { path: queryPath, name: params.meta.title, active: true });
      }
      // 替换下标签
      if (flag && canAdd(params.path)) {
        routeArr.splice(currentIndex - 1, 1, { path: queryPath, name: params.meta.title, active: true });
      }

      context.emit('userSelectPath', params.path);
    }
    // 删除一个数组项
    function deleteItem(index:number) {
      if (routeArr.length === 1) {
        return;
      }

      routeArr.splice(index, 1);
      const redirectIndex = index - 1;
      lastPath = routeArr[redirectIndex].name;
      store.commit('DELETE_CACHE_COMPONENTS_PATH', routeArr[redirectIndex].path);
      router.push(routeArr[redirectIndex].path);
    }

    watch(() => route.path, () => {
      checkActive(route);
    }, {
      immediate: true,
    });
    return {
      routeArr,
      toRedirect,
      deleteItem,
      showClose,
    };
  },
});
